import { render, staticRenderFns } from "./MembershipDetail.vue?vue&type=template&id=53c16ecc"
import script from "./MembershipDetail.vue?vue&type=script&lang=ts"
export * from "./MembershipDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports